const getFullFormattedDate = (rawDate: Date) => {
  if (rawDate == null || !(rawDate instanceof Date)) {
    return '';
  }

  // Get the Policy response model and transform to a View Model
  const month = rawDate.getMonth();
  const day = rawDate.getDate();
  const year = rawDate.getFullYear();

  // Validate if the date is correct - if any of the day, month and year is not a number
  if (day.toString() === 'NaN' || month.toString() === 'NaN' || year.toString() === 'NaN') {
    return '';
  }

  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  return day + ' ' + monthNames[month] + ' ' + year;
};

const getShortFormattedDate = (rawDate: Date) => {
  if (rawDate == null || !(rawDate instanceof Date)) {
    return '';
  }

  // Get the Policy response model and transform to a View Model
  const month = rawDate.getMonth() + 1;
  const day = rawDate.getDate();
  const year = rawDate.getFullYear();

  // Validate if the date is correct - if any of the day, month and year is not a number
  if (day.toString() === 'NaN' || month.toString() === 'NaN' || year.toString() === 'NaN') {
    return '';
  }

  return ('0' + day).slice(-2) + '/' + ('0' + month).slice(-2) + '/' + year;
};

export { getFullFormattedDate, getShortFormattedDate };
